import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'mmb-web-app-user-life-goal-info',
  templateUrl: './user-life-goal-info.component.html',
  styleUrls: ['./user-life-goal-info.component.scss']
})
export class UserLifeGoalInfoComponent implements OnInit {
  @Input() summary: string;
  lookingForItems: any[] = [{
    name: 'Co-founder / business partner'
  }, {
    name: 'Investment / funding'
  }, {
    name: 'Mentorship'
  }];

  interestItems: any[] = [{
    name: 'Finance'
  }, {
    name: 'Sport'
  }, {
    name: 'Recreation'
  }];

  interestedInCountriesItems: any[] = [{
    name: 'Brazil'
  }, {
    name: 'Egypt'
  }, {
    name: 'USA'
  }];
  constructor() { }

  ngOnInit() {
  }

}
